import { LogoWrapper, LogoImage } from './logo.styled';

const Logo = () => {
  return (
    <>
      <LogoWrapper>
        <LogoImage />
      </LogoWrapper>
    </>
  );
};

export default Logo;
